import {
  AssetsInterface,
  FoldersWithAssetsInterface,
  FolderDataInterface,
} from "@/types";

export function extractNestedAssets(
  albums: FoldersWithAssetsInterface[] | FolderDataInterface[]
): AssetsInterface[] {
  let assets: AssetsInterface[] = [];

  const extractAssets = (
    album: FoldersWithAssetsInterface | FolderDataInterface
  ) => {
    assets = [...assets, ...album.assets];
    album.folders.forEach(extractAssets);
  };

  albums.forEach(extractAssets);

  return assets;
}
